export default function* failure({ res }) {
  // console.log(res)
}
